import { createSelector } from 'reselect';
import get from 'lodash/get';

import { Messages } from 'models/messages';
import DeepLink from 'models/deep-link';

const readProp = (slice, key, defaultValue) => {
  if (!slice) {
    return defaultValue;
  }
  if (typeof slice.get === 'function') {
    const val = slice.get(key);
    return val !== undefined ? val : defaultValue;
  }
  return get(slice, key, defaultValue);
};

export const getMessagingState = state => get(state, 'messaging', null);

export const getMessages = createSelector(
  [getMessagingState],
  messaging => readProp(messaging, 'messages', Messages()),
);

export const getDeepLinksState = state => get(state, 'deepLinks', null);

export const getDisplayDeepLink = createSelector(
  [getDeepLinksState],
  deepLinks => Boolean(readProp(deepLinks, 'display', false)),
);

export const getDeepLinkMessage = createSelector(
  [getDeepLinksState],
  deepLinks => readProp(deepLinks, 'message', ''),
);

export const getDeepLink = createSelector(
  [getDeepLinksState],
  deepLinks => readProp(deepLinks, 'deepLink', new DeepLink()),
);
